
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_1wx92_97",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_1wx92_143",
  "badge-color-green": "awsui_badge-color-green_1yjyg_1wx92_146",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_1wx92_149",
  "badge-color-red": "awsui_badge-color-red_1yjyg_1wx92_152"
};
  